import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@eatclubcode/ec-component-library';
import useStyles from './DineAnytimeStyles';
import DineAnytimeSVG from '../../assets/dine_anytime.svg';

export const DineAnytime = ({ isBig = false }) => {
  const classes = useStyles({ isBig });

  return (
    <Box className={classes.root}>
      <DineAnytimeSVG className={classes.icon} />
      Dine Anytime
    </Box>
  );
};

DineAnytime.propTypes = {
  isBig: PropTypes.bool,
};
